/** Opening a project in a browser window of its own.
 *
 * Named per project, so clicking the same project twice brings its window forward rather
 * than stacking a second copy. Deliberately not `noopener`: a window opened by script
 * inherits this tab's session storage, which is where the sign-in lives — with `noopener`
 * the new window would start signed out.
 *
 * `?window=1` marks the page as a project window: the shell drops its navigation rail, and
 * Close closes the window rather than navigating.
 */

const WINDOW_FLAG = 'window'

export function projectWindowUrl(id: string): string {
  return `/projects/${id}?${WINDOW_FLAG}=1`
}

export function openProjectWindow(id: string): void {
  const width = Math.min(1360, window.screen.availWidth - 80)
  const height = Math.min(1000, window.screen.availHeight - 80)
  const opened = window.open(
    projectWindowUrl(id),
    `wpmt-project-${id}`,
    `popup,width=${width},height=${height},left=60,top=40`,
  )
  // A blocked pop-up still has to open the project somewhere.
  if (!opened) window.location.assign(`/projects/${id}`)
  else opened.focus()
}

export function isProjectWindow(): boolean {
  return new URLSearchParams(window.location.search).get(WINDOW_FLAG) === '1'
}
